// src/services/apiService.ts
import axios from 'axios';

export interface ApiKey {
  id?: string;
  api_key: string;
  api_secret?: string;
}

export const fetchApiKeys = async () => {
  const response = await axios.get('/api/get-api-keys');
  return response.data;
};

export const deleteApiKey = async (id: string) => {
  await axios.delete(`/api/keys/${id}`);
};

export const createApiKey = async () => {
  const response = await axios.post('/api/generate-api-key');
  return response.data;
};
